import DealerInventoryPanel from "./dealerInventoryPanel.container"

export default DealerInventoryPanel
